import { branch, compose, renderNothing } from 'recompose'
import { connect } from 'react-redux'
import { selectLoadingState } from 'src/store/selectors/layout'

const FooterContainer = compose(
  connect(state => ({
    loading: selectLoadingState(state)
  })),
  branch(({ loading }) => loading, renderNothing)
)

export default FooterContainer
